import React from "react"
import PropTypes from "prop-types"

import P from "components/atoms/P"
import H from "components/atoms/H"

import {
  StyledHeroSection,
  paragraphStyles,
  headerStyles,
  visuallyHiddenStyles,
} from "./AboutHeroSection.styles"

const HeroSection = ({ sectionData }) => {
  return (
    <StyledHeroSection>
      <H as="h1" extraStyles={headerStyles}>
        {sectionData.header}
      </H>
      <H as="h2" extraStyles={visuallyHiddenStyles}>
        About Exdev
      </H>
      <P extraStyles={paragraphStyles}>{sectionData.description}</P>
    </StyledHeroSection>
  )
}

export default HeroSection

HeroSection.propTypes = {
  sectionData: PropTypes.shape({
    header: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
}
